import {
    type FC
} from "react";
import {
    Platform,
    View
} from "react-native";
import type IAnimatedIconTransitionProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize
} from "../../../../core/hooks";
import {
    ANIMATED_ICON_REST_PROGRESS
} from "../../constant";
import useAnimatedIconValue from "../../useAnimatedIconValue";
import AnimatedIconLayer from "../layer";

const AnimatedIconTransition: FC<IAnimatedIconTransitionProps> = ({
    customTheme,
    isMirrored,
    progress,
    color,
    label,
    plan,
    size
}) => {
    const {
        direction
    } = NCoreUIKitLocalize.useContext();

    const currentProgress = useAnimatedIconValue({
        isStatic: Platform.OS === "web",
        initialValue: plan.start,
        progress
    });

    const {
        container: containerDynamicStyle
    } = useStyles({
        isMirrored,
        direction,
        size
    });

    const isDecorative = !label;

    return <View
        aria-hidden={isDecorative ? true : undefined}
        role={isDecorative ? undefined : "img"}
        accessible={!isDecorative}
        style={[
            stylesheet.container,
            containerDynamicStyle
        ]}
        aria-label={label}
    >
        {
            plan.shared.nodes.length ?
                <AnimatedIconLayer
                    progress={currentProgress}
                    customTheme={customTheme}
                    parts={plan.shared.parts}
                    nodes={plan.shared.nodes}
                    color={color}
                    size={size}
                />
            :
                null
        }
        {
            Platform.OS === "web" || currentProgress < ANIMATED_ICON_REST_PROGRESS ?
                <AnimatedIconLayer
                    progress={currentProgress}
                    customTheme={customTheme}
                    parts={plan.from.parts}
                    nodes={plan.from.nodes}
                    value={progress}
                    color={color}
                    isRestHidden
                    isCrossfade
                    size={size}
                />
            :
                null
        }
        <AnimatedIconLayer
            progress={currentProgress}
            customTheme={customTheme}
            parts={plan.to.parts}
            nodes={plan.to.nodes}
            value={progress}
            color={color}
            isCrossfade
            size={size}
        />
    </View>;
};
export default AnimatedIconTransition;
